const uslug = require('uslug');

function getArticlePath(article) {
  if (article.prebuilt_url?.indexOf('/news/') === 0) {
    return article.prebuilt_url;
  }

  return '/news/' + `${article.id}`;
}

function getProductPath(product) {
  if (product.prebuilt_url?.indexOf('/medical_service/') === 0) {
    return product.prebuilt_url;
  }

  return '/medical_service/' + `${product.id}`;
}

module.exports = {
  getArticlePath,
  getProductPath,
};
